import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import { PAIDY_HOST } from 'src/constants';
import Slider from 'react-slick';
import classNames from 'classnames';

import { useMediaQuery } from '@material-ui/core';

import ImgAppleMerchantBanner from 'src/images/homepage-20250811/apple-4x-v2.png';
import ImgAmazonMerchantBanner from 'src/images/homepage-20250811/amazon-4x.png';
import ImgTenthAnniversaryBanner from 'src/images/homepage-20250811/anniversary-4x.png';
import ImgTVCMBanner from 'src/images/homepage-20250811/tvcm-4x.png';

import styles from './HomeSlider.module.scss';

function NextArrow({ className, ...restProps }) {
  return (
    <div className={classNames(className, styles.nextArrow)} {...restProps} />
  );
}

function PrevArrow({ className, ...restProps }) {
  return (
    <div className={classNames(className, styles.prevArrow)} {...restProps} />
  );
}

const SETTINGS = {
  className: 'slider variable-width',
  centerPadding: '12px',
  slidesToShow: 2,
  swipe: true,
  dots: true,
  variableWidth: true,
  autoplay: true,
  dotsClass: styles.slickDots,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  appendDots: (dots) => (
    <div>
      <ul className={styles.dots}>{dots}</ul>
    </div>
  ),
  customPaging: () => <div className={styles.dot} />,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const SLIDES_TCVM = [
  {
    key: 'Apple banner',
    img: ImgAppleMerchantBanner,
    alt: 'Apple banner',
    to: `https://www.apple.com/jp/shop/buy-iphone?cid=aos-jp-aff-bp-paidy-paidycarouselbanner-iphone-17and17pro_cta-2025npi`,
    text:
      '※その他の取引条件については、当社ホーム\nページの各種利用規約をご確認ください。',
  },
  {
    key: 'Amazon banner',
    img: ImgAmazonMerchantBanner,
    alt: 'Amazon banner',
    to: 'https://www.amazon.co.jp/b?node=8215625051',
  },
  {
    key: '2025tvcm',
    img: ImgTVCMBanner,
    alt: 'TCVM LP',
    to:
      '/perspective_202505/?utm_source=web&utm_medium=webpage&utm_campaign=TVCM_2505&utm_content=banner_web',
  },
  {
    key: '10th anniversary',
    img: ImgTenthAnniversaryBanner,
    alt: '10th anniversary',
    to: `${PAIDY_HOST}/10th-anniversary/`,
  },
];

export default function TopMerchantBanners({ slides = SLIDES_TCVM, id }) {
  const isMobile = useMediaQuery('(max-width:646px)');

  return (
    <section id={id} className={styles.section}>
      <div className={styles.container}>
        {isMobile ? (
          <Slider {...SETTINGS}>
            {slides.map((slide) => (
              <OutboundLink
                key={slide.key}
                href={slide.to}
                target="_blank"
                rel="noopener noreferrer"
                className={`ga_click_carousel_banner_${
                  slide.key.split(' ')[0]
                }`}
              >
                <div className={styles.bannerItem}>
                  <img
                    src={slide.img}
                    alt={slide.alt}
                    height={224}
                    width={168}
                    className={classNames(styles.img)}
                  />
                  {/* Add text below the image */}
                  <p className={styles.bannerText}>{slide.text}</p>
                </div>
              </OutboundLink>
            ))}
          </Slider>
        ) : (
          // Just show the images in a row (or styled with CSS)
          <div className={styles.desktopBanners}>
            {slides.map((slide) => (
              <OutboundLink
                key={slide.key}
                href={slide.to}
                target="_blank"
                rel="noopener noreferrer"
                className={`ga_click_carousel_banner_${
                  slide.key.split(' ')[0]
                }`}
              >
                <div className={styles.bannerItem}>
                  <img
                    src={slide.img}
                    alt={slide.alt}
                    height={224}
                    width={168}
                    className={classNames(styles.img)}
                  />
                  <p className={styles.bannerText}>{slide.text}</p>
                </div>
              </OutboundLink>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
